module.exports = __webpack_public_path__ + "fed/fe-autoinfo-web/asset-1907/image/logo/logo-text-white.afe276d9.svg";